import Svg, { Path } from "react-native-svg";
import { GetProps } from "tamagui";

const WeightScale = ({ color, ...props }: GetProps<typeof Svg>) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <Path
      d="M12 8.38281L13.5141 5.88281M4.79131 23H19.2087C19.7072 23 20.1311 22.6395 20.2065 22.1513L22.9883 4.14226C23.0566 3.70037 22.8212 3.26541 22.4056 3.09125C15.7518 0.302916 8.24817 0.302916 1.59442 3.09125C1.17883 3.26541 0.943431 3.70036 1.01169 4.14226L3.7935 22.1513C3.86891 22.6395 4.29278 23 4.79131 23ZM7.17722 19.8828H16.8228C17.3213 19.8828 17.7452 19.5223 17.8206 19.0341L18.8881 12.1229C18.9817 11.5174 18.5087 10.9717 17.8903 10.9717H6.10967C5.49134 10.9717 5.01833 11.5174 5.11186 12.1229L6.17942 19.0341C6.25483 19.5223 6.6787 19.8828 7.17722 19.8828ZM5.34263 4.7465C9.64684 3.2183 14.3532 3.2183 18.6574 4.7465C18.9025 4.83352 19.066 5.06365 19.066 5.32157V7.38281C19.066 7.9351 18.614 8.38281 18.0565 8.38281H5.94346C5.38597 8.38281 4.93403 7.9351 4.93403 7.38281V5.32157C4.93403 5.06365 5.09754 4.83352 5.34263 4.7465Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Svg>
);

export default WeightScale;
